import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import React from 'react';
import useStyles from '../../../../style/js-style/containers/administration/personalization/personalizationStyle';
import InputItemsSubSection from './InputItem';
import EAColorIcon from '../../../../components/common/EAColorIcon';
import { COLOR_TYPE } from '../themeUtils';
import { PrivilegeEnum, RoleBasedAccessControlContext } from '../../../../services/common/RolesUtils';

const AppearanceSubSection = ({
                                title,
                                notice,
                                optionsItems,
                                setOption,
                                selectedOption,
                                isCustomTemplate,
                                setUploadedLogo,
                                hasRemovedLogo = false,
                                preview = [],
                                setHasRemovedLogo = () => {},
                                setPreview = () => {},
                                type}) => {
  const { classes } = useStyles();
  const { hasAnyOfPrivileges } = React.useContext(RoleBasedAccessControlContext);

  return (
    <div className={classes.appearanceItem}>

      {/* Titre & notice */}
      <div className={classes.appearanceItemTitle}>
        {title}
      </div>
      <div className={classes.appearanceItemNotice}>
        {notice}
      </div>

      {/* Liste des options */}
      <div className={classes.appearanceItemRadioGroup}>
        <RadioGroup
          row
          value={selectedOption}
          onChange={(e) => setOption(e.currentTarget.value)}

        >
          {optionsItems.map((item) => { return (
            <FormControlLabel
              value={item.value}
              control={
                <Radio
                  size="small"
                  color="primary"
                  disabled={!item.isAuthorized}
                  icon={<EAColorIcon icon={'input/radio-unchecked'} />}
                  checkedIcon={<EAColorIcon icon={'input/radio-checked'} />}
                  sx={{backgroundColor: "transparent !important"}}
                />
              }
              label={<span style={{position: "relative", top: "-1px"}}>{item.label}</span>}
            />
          );})}
        </RadioGroup>
      </div>

      {/* Inputs */}
      <InputItemsSubSection
        optionsItems={optionsItems}
        selectedOption={selectedOption}
        setUploadedLogo={setUploadedLogo}
        hasRemovedLogo={hasRemovedLogo}
        preview={preview}
        setHasRemovedLogo={setHasRemovedLogo}
        setPreview={setPreview}
        disabled={!hasAnyOfPrivileges(PrivilegeEnum.PRIVILEGE_EDIT_THEME_PARAMETERS)}
        type={type}
      />

      {type !== COLOR_TYPE && isCustomTemplate &&
        <hr className={classes.separator}/>
      }
    </div>
  )
}

export default AppearanceSubSection;